import React from 'react'

import styled from 'styled-components'

import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'
import { GenreWithCurators } from 'src/Redux/spotifyCampaignGenresApi'
import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { filterAndSortGenres } from 'src/Constants/functions'
import { renderLanguageOrGenreName } from 'src/Components/GenresList/helpers'
type Props = {
  genres?: GenreWithCurators[]
  searchValue: string
  onClickGenre: (genre: GenreWithCurators) => void
  selectedGenres?: GenreWithCurators[]
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  margin: 0;
`
const List = styled.ul`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`
const NoResults = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const NoResultsContainer = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

export const SearchGenresList: React.FC<Props> = ({
  genres,
  onClickGenre,
  searchValue,
  selectedGenres,
}) => {
  const filteredGenres = filterAndSortGenres(
    genres || [],
    searchValue,
    'genreName',
  )

  if (!filteredGenres || filteredGenres.length === 0) {
    return (
      <NoResultsContainer>
        <InfoIcon width={16} height={16} />
        <NoResults>No search results</NoResults>
      </NoResultsContainer>
    )
  }

  return (
    <Container>
      <Title>Search results</Title>
      <List>
        {filteredGenres.map((genre) => (
          <LabelForGenreOrLanguage
            key={genre.id}
            title={renderLanguageOrGenreName(genre.genreName, searchValue)}
            count={genre.curatorsCount}
            markedSelected={selectedGenres?.some(
              (selectedGenre) => selectedGenre.id === genre.id,
            )}
            onClick={() => onClickGenre(genre)}
          />
        ))}
      </List>
    </Container>
  )
}
